export default __webpack_public_path__ + "static/media/letterbox-glyph-16px.f742b708.svg";